export default __webpack_public_path__ + "static/media/849.fb32bb81.gif";